import React, { FC, ChangeEvent } from 'react';
import styles from './textareaComponent.module.css';

type PropsType = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const TextareaComponent: FC<PropsType> = ({ value, onChange, placeholder }) => {
  const onTextareaChange = (e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.currentTarget.value);

  return (
        <textarea
            className={styles.textarea}
            value={value}
            onChange={onTextareaChange}
            placeholder={placeholder}
        ></textarea>
  );
};

export default TextareaComponent;
